import { type AiOfferListRequestDTO, type AiOfferListResponseDTO } from 'ecosystem'
import { baseSplitApi, type BaseSplitApiExtendable } from '../../store-utils'

export const generateGetAiOffersEndpoint = <T extends BaseSplitApiExtendable>(rtkBaseApi: T) => {
  return rtkBaseApi.injectEndpoints({
    endpoints: (builder) => ({
      getAiOffers: builder.query<AiOfferListResponseDTO, AiOfferListRequestDTO>({
        query: (args) => ({
          url: `ai-offers/get-list`,
          method: 'POST',
          body: args
        }),
        transformResponse: (aiOffers: AiOfferListResponseDTO) => {
          return aiOffers.map((offer) => ({
            ...offer,
            products: offer.products?.map((offerProduct) => ({
              ...offerProduct,
              product: {
                ...offerProduct.product,
                price: offerProduct.discountedPrice,
                originalPrice: offerProduct.product.price
              }
            }))
          }))
        }
      })
    }),
    overrideExisting: true
  })
}

export const getAiOffersEndpoint = generateGetAiOffersEndpoint(baseSplitApi)

export const { useGetAiOffersQuery } = getAiOffersEndpoint
